import Vue from "vue";
import VueRouter from "vue-router";

import ClassAddressingRandom from "../components/ClassAddressingRandom";
import ClassAddressingInput from "../components/ClassAddressingInput";
import CIDRAddressingForm from "../components/CIDRAddressingForm";
import SimmetricalSubnettingForm from "../components/SimmetricalSubnettingForm";
import AsimmetricalSubnettingForm from "../components/AsimmetricalSubnettingForm";

Vue.use(VueRouter);

export default new VueRouter({
    routes: [
        { 
            path: "/ipclass/generate",
            component: ClassAddressingRandom
        },
        {
            path: "/ipclass/solve",
            component: ClassAddressingInput
        },
        {
            path: "/ipcidr/both",
            component: CIDRAddressingForm
        },
        {
            path: "/subnetting/simmetrical",
            component: SimmetricalSubnettingForm,
        },
        {
            path: "/subnetting/asimmetrical",
            component: AsimmetricalSubnettingForm,
/*            props: {
                initialnetaddress: "192.168.1.0",
                initialnetmaskcidr: 24,
                segments: [
                    {
                        name: "Production",
                        hosts: 52
                    },
                    {
                        name: "Wan 1",
                        hosts: 2
                    },
                    {
                        name: "Development",
                        hosts: 74
                    },
                    {
                        name: "Wan 2",
                        hosts: 2
                    },
                    {
                        name: "Administration",
                        hosts: 28
                    },
                    {
                        name: "Wan 3",
                        hosts: 2
                    }
                ]
            }*/
        }
    ]
})